/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 25.05.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {Checkbox as ReactCheckbox} from "react-icheck";

class Checkbox extends React.Component {
    static propTypes = {
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string,PropTypes.number,PropTypes.bool]),
        checkedValue: PropTypes.oneOfType([PropTypes.string,PropTypes.number,PropTypes.bool]),
        uncheckedValue: PropTypes.oneOfType([PropTypes.string,PropTypes.number,PropTypes.bool]),
        label: PropTypes.string,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        /**
         * onChange(name, value)
         * If checkbox is checked then the value is equal to "defaultValue" property, otherwise the value is null.
         */
        onChange: PropTypes.func
    };

    static defaultProps = {
        checkedValue: true,
        uncheckedValue: null,
        disabled: false,
        className: "icheckbox_square-green"
    };

    constructor(props) {
        super(props);
        this.state = {
            value: props.value
        };

        this.onChange = this.onChange.bind(this);
    }

    onChange(e, checked) {
        if (this.props.onChange) this.props.onChange(this.props.name, (checked ? this.props.checkedValue : this.props.uncheckedValue) );
        else this.setState({value: (checked ? this.props.checkedValue : this.props.uncheckedValue)});
    }

    render() {
        let label = "";
        // Add NBSP before label:
        if (this.props.label) label = "\u00A0" + this.props.label;
        let value = (this.props.onChange ? this.props.value : this.state.value);
        return (
            <ReactCheckbox
                name={this.props.name}
                checkboxClass={this.props.className}
                increaseArea="20%"
                label={label}
                onChange={this.onChange}
                value={this.props.checkedValue}
                checked={value === this.props.checkedValue}
                disabled={this.props.disabled} />
        );
    }
}

export default Checkbox;
